var locale = {
    'NO_SITES': 'No records',
    'SAVE':'Enregistrer'
}
export default locale;